import { mediaQueries } from '@everlywell/leaves';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.section`
  margin-left: -24px;
  margin-right: -24px;

  ${mediaQueries.forTabletHorizontalUp} {
    margin-left: 0;
    margin-right: 0;
  }
`;

const BgImg = styled(GatsbyImage)`
  display: block;
  width: 100%;
  max-height: 212px;

  ${mediaQueries.forTabletVerticalUp} {
    max-height: 303px;
  }

  ${mediaQueries.forTabletHorizontalUp} {
    max-height: 319px;
  }

  ${mediaQueries.forDesktopUp} {
    max-height: 456px;
  }
`;

const Hero = ({ image }) => {
  const myImage = getImage(image);
  return (
    <Wrapper>
      <BgImg image={myImage} loading="eager" alt={image.description} />
    </Wrapper>
  );
};

export default Hero;
